import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { USER_ROLES } from '@shared/constant/shared.constant';
import { SuperAdminService } from '@core/services/super-admin.service';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSucessComponent implements OnInit {
  assistedBookingListUrl: string;
  bodyText: string;
  heading: string = ""
  buttonText: string;
  userRoles = USER_ROLES;
  selectedUserId: any;
  redirectUrl: any;
  isrefresh: boolean = false;
  bookingId: string;
  bookingType: number;
  userCrmTab: number;
  userId: string;

  constructor(
    private readonly ref: DynamicDialogRef,
    private readonly router: Router,
    public readonly config: DynamicDialogConfig,
    private readonly superAdminService: SuperAdminService
  ) { }

  ngOnInit() {
    this.userId = this.config?.data?.userId;
    this.assistedBookingListUrl = this.config.data.assistedUrl;
    this.bodyText = this.config.data.bodyText;
    this.buttonText = this.config.data.buttonText;
    this.heading = this.config?.data?.heading;
    this.selectedUserId = this.config?.data?.selectedUserId || this.userId;
    this.redirectUrl = this.config?.data?.redirectUrl;
    this.isrefresh = this.config?.data?.isrefresh;
    this.bookingId = this.config?.data?.bookingId;
    this.bookingType = this.config?.data?.bookingType;
    this.userCrmTab = (this.bookingType === 0) ? 0 : 3;
  }

cancelDialog(): void {
    this.ref.close();
    if (this.assistedBookingListUrl) {
      if (this.assistedBookingListUrl !== '/login') {
        if (this.assistedBookingListUrl === 'super-admin/driver-info' ||
          this.assistedBookingListUrl === 'manager/driver-info' ||
          this.assistedBookingListUrl === 'super-admin/group-operator-info' ||
          this.assistedBookingListUrl === 'manager/group-operator-info') {
          const paramName = (this.assistedBookingListUrl === 'super-admin/group-operator-info' ||
            this.assistedBookingListUrl === 'manager/group-operator-info')
            ? 'Id' : 'id';
          const url = `${this.assistedBookingListUrl}?${paramName}=${this.selectedUserId}&tab=${this.userCrmTab}`;
          const navigation: NavigationExtras = {
            state: {
              redirectUrl: this.redirectUrl
            },
          };
          this.router.navigateByUrl(url, navigation);
        }
        else {
          if (this.assistedBookingListUrl === 'group-operator/booking-list' || this.assistedBookingListUrl === 'driver/booking') {
            this.router.navigate([this.assistedBookingListUrl], {
              queryParams: { tab: (this.bookingType === 0) ? 0 : 1  }  // Pass queryParams separately
            });
          } else {
            this.router.navigate([this.assistedBookingListUrl]);
          }
        }
      } else {
        this.router.navigate([this.assistedBookingListUrl]);
      }
    }
  }

  closeAndRefresh() {
    this.ref.close();
    this.superAdminService.triggerPopupClose(true); // Emit event to refresh list

  }

  okButtonRedirectiononExtendBooking() {
    this.ref.close();
    this.router.navigate([this.assistedBookingListUrl], { queryParams: { id: this.bookingId, assisted: false } });
    }
}
